<template>
  <transition name="el-fade-in">
    <div class="avatar-cropper" v-if="visible">
      <i class="close el-icon-close" @click="close"></i>
      <div class="imageBox">
        <div class="thumbBox"></div>
        <div class="spinner" style="display: none">Loading...</div>
      </div>
      <div class="action">
        <span class="btnZoomOut" @click="zoomOut" style="float: left">
          <i class="el-icon-minus"></i>
        </span>
        <input
          type="range"
          class="range"
          step="5"
          min="0"
          @change="stepChange"
          max="100"
          v-model.number="stepradio"
        />
        <span class="btnZoomIn" @click="zoomIn" style="float: left">
          <i class="el-icon-plus"></i>
        </span>
        <a id="btnCrop" @click="uploadAvatar" class="save" style="float: left"
          >保存</a
        >
      </div>
    </div>
  </transition>
</template>
<script>
import Cropbox from "@/assets/js/cropbox";
import { mapActions } from "vuex";
import SparkMD5 from "@/assets/js/spark-md5.min";
import {FileUpload} from '@/assets/js/common'
import _ from "lodash";
export default {
  name: "avatar-cropper",
  data() {
    return {
      visible: false,
      stepradio: 50,
      laststepradio: 50,
      zoomradio: 0,
      cropper: ",",
      options: {
        imageBox: ".imageBox",
        thumbBox: ".thumbBox",
        spinner: ".spinner",
        imgSrc: ""
      },
      resolve: null,
      reject: null
    };
  },
  methods: {
    ...mapActions('post', ['queryUpload', 'uploadFile', 'getFileSrc']),
    async uploadAvatar() {
      const imgBlob = this.cropper.getBlob()
      const file = new File([imgBlob], 'avatar.png', {type: this.file.type})
           let {data} = await this.uploadFile({file: file, onProgress: (progressEvent) => {}})
           this.resolve({ action: 'confirm', url: data.url})
           this.visible = false
    },
    zoomOut() {
      this.zoomradio--;
      if (this.zoomradio < -10) {
        this.zoomradio++;
        this.laststepradio = this.stepradio;
        return;
      }
      this.stepradio -= 5;
      this.laststepradio = this.stepradio;
      this.cropper.zoomOut();
    },
    zoomIn() {
      this.zoomradio++;
      if (this.zoomradio > 10) {
        this.zoomradio--;
        this.laststepradio = this.stepradio;
        return;
      }
      this.stepradio += 5;
      this.laststepradio = this.stepradio;
      this.cropper.zoomIn();
    },
    initCropbox: function() {
      this.options.imgSrc = this.imgSrc;
      let cropper = new Cropbox(this.options);
      this.cropper = cropper;
    },
    close: function() {
      this.resolve({ action: "close" });
      this.visible = false;
    },
    stepChange: function() {
      const radionum = (_.toInteger(this.stepradio) - this.laststepradio) / 5;
      var radio = 1;
      if (radionum > 0) {
        for (let i = 0; i < Math.abs(radionum); i++) {
          this.zoomradio++;
          radio *= 1.25;
        }
        this.cropper.zoomIn(radio);
      }
      if (radionum < 0) {
        for (let i = 0; i < Math.abs(radionum); i++) {
          this.zoomradio--;
          radio *= 0.8;
        }
        this.cropper.zoomOut(radio);
      }
      this.laststepradio = this.stepradio;
    }
  },
  mounted() {
    this.initCropbox();
  }
};
</script>
<style lang="scss" scoped>
.avatar-cropper {
  position: fixed;
  background-color: #fff;
  margin-top: 15vh;
  top: 0;
  right: 20%;
  width: 360px;
  height: 410px;
  padding: 30px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  z-index: 2100;
  .close {
    position: absolute;
    top: 10px;
    right: 12px;
    font-size: 18px;
    color: #0057ff;
    cursor: default;
    &:hover {
      cursor: pointer;
    }
  }
}
.action {
  width: 360px;
  height: 30px;
  margin: 10px 0;
  > span {
    text-align: center;
    display: inline-block;
    width: 18px;
    height: 18px;
    margin-right: 10px;
    border-radius: 9px;
    background-color: rgba(0, 0, 0, 0.1);
    &:hover {
      cursor: pointer;
    }
  }
  > .btnZoomIn {
    margin-left: 10px;
  }
  > .save {
    text-align: center;
    text-decoration: none;
    width: 60px;
    color: #0057ff;
    height: 20px;
    &:hover {
      cursor: pointer;
    }
  }
  input[type="range"] {
    display: block;
    padding-top: 5px;
    margin: 0 auto;
    width: 180px;
    height: 8px;
    vertical-align: top;
    background: transparent;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;
    float: left;
  }
  input[type="range"]:focus {
    outline: none;
  }
  input[type="range"]::-webkit-slider-thumb {
    -webkit-box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.18);
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.18);
    -webkit-appearance: none;
    appearance: none;
    margin-top: -3px;
    width: 12px;
    height: 12px;
    background-color: #0057ff;
    border-radius: 100%;
    border: none;
    -webkit-transition: 0.2s;
    transition: 0.2s;
  }
  input[type="range"]::-moz-range-thumb {
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.18);
    -moz-appearance: none;
    appearance: none;
    width: 12px;
    height: 12px;
    background-color: #0057ff;
    border-radius: 100%;
    border: none;
    -webkit-transition: 0.2s;
    transition: 0.2s;
  }
  input[type="range"]::-ms-thumb {
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.18);
    appearance: none;
    width: 12px;
    height: 12px;
    background-color: #0057ff;
    border: none;
    border-radius: 100%;
    -webkit-transition: 0.2s;
    transition: 0.2s;
  }
  input[type="range"]:active::-moz-range-thumb {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
    width: 14px;
    height: 14px;
  }
  input[type="range"]:active::-ms-thumb {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
    width: 14px;
    height: 14px;
  }
  input[type="range"]:active::-webkit-slider-thumb {
    -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);
    margin-top: -4px;
    width: 14px;
    height: 14px;
  }
  input[type="range"]::-webkit-slider-runnable-track {
    -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    width: 100%;
    height: 6px;
    cursor: pointer;
    border-radius: 2px;
    border: none;
    background-color: rgba(0, 97, 255, 0.3);
  }
  input[type="range"]::-moz-range-track {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    width: 100%;
    height: 6px;
    cursor: pointer;
    border-radius: 2px;
    border: none;
    background-color: rgba(0, 97, 255, 0.3);
  }
  input[type="range"]::-ms-track {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    width: 100%;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
    height: 6px;
    border-radius: 2px;
    border: none;
  }
  input[type="range"]::-ms-fill-lower {
    background-color: rgba(0, 97, 255, 0.3);
  }
  input[type="range"]::-ms-fill-upper {
    background-color: rgba(0, 97, 255, 0.15);
  }
  input[type="range"]:focus::-webkit-slider-runnable-track {
    background-color: rgba(0, 97, 255, 0.5);
  }
  input[type="range"]:focus::-moz-range-track {
    background-color: rgba(0, 97, 255, 0.5);
  }
  input[type="range"]:focus::-ms-fill-lower {
    background-color: rgba(0, 97, 255, 0.45);
  }
  input[type="range"]:focus::-ms-fill-upper {
    background-color: rgba(0, 97, 255, 0.25);
  }
}
.imageBox {
  position: relative;
  height: 300px;
  width: 300px;
  border: 1px solid #aaa;
  background: #fff;
  overflow: hidden;
  background-repeat: no-repeat;
  cursor: move;
  border-radius: 4px;
}

.imageBox .thumbBox {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200px;
  height: 200px;
  margin-top: -100px;
  margin-left: -100px;
  box-sizing: border-box;
  border: 1px solid rgb(102, 102, 102);
  box-shadow: 0 0 0 1000px rgba(0, 0, 0, 0.5);
  background: none repeat scroll 0% 0% transparent;
  border-radius: 100px;
}

.imageBox .spinner {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  text-align: center;
  line-height: 360px;
  background: rgba(0, 0, 0, 0.7);
}
</style>
